import { memo } from 'react';
import AMLDetailsModal from './components/AMLDetailsModal/AMLDetailsModal';
import AddressWarningModal from './components/AddressWarningModal';
import AmlHighRisk from './components/AmlHighRisk';
import BillingDetail from './components/BillingDetail';
import BillingInfoModal from './components/BillingInfoModal';
import CardDetailsInfo from './components/CardDetailsInfo';
import ChangeFeePaymentMethod from './components/ChangeFeePaymentMethod';
import ChoosePeriodModal from './components/ChoosePeriodModal';
import CloseCard from './components/CloseCard';
import DeleteHash from './components/DeleteHash';
import ExportTransactionsModal from './components/ExportTransactionsModal';
import FreezeCard from './components/FreezeCard';
import LearnAboutAmlRisk from './components/LearnAboutAmlRisk/LearnAboutAmlRisk';
import LearnAboutAmlRiskModal from './components/LearnAboutAmlRiskModal/LearnAboutAmlRiskModal';
import ModalCurrencyList from './components/ModalCurrencyList';
import PaymentConfiguration from './components/PaymentConfiguration';
import PaymentConfigurationInfo from './components/PaymentConfigurationInfo';
import PeriodSelectModal from './components/PeriodSelectModal';
import PinCode from './components/PinCode';
import PwaInstallInstruction from './components/PwaInstallInstruction';
import SelectNetwork from './components/SelectNetwork';
import ShowFilesModal from './components/ShowFiles';
import TransactionFilesModal from './components/TransactionFilesModal';

const modals = {
	DeleteHash,
	PinCode,
	BillingDetail,
	ChangeFeePaymentMethod,
	ChoosePeriodModal,
	PeriodSelectModal,
	BillingInfoModal,
	PaymentConfiguration,
	PaymentConfigurationInfo,
	PwaInstallInstruction,
	LearnAboutAmlRisk,
	LearnAboutAmlRiskModal,
	FreezeCard,
	AMLDetailsModal,
	SelectNetwork,
	CardDetailsInfo,
	ModalCurrencyList,
	AmlHighRisk,
	ExportTransactionsModal,
	CloseCard,
	TransactionFilesModal,
	ShowFilesModal,
	AddressWarningModal,
};

const RootModalSwitch = memo(function RootModalSwitch({ modal }) {
	const { tag } = modal;
	const CustomRootModal = modals[tag];
	if (!CustomRootModal) {
		console.error(`RootModal ${tag} not found`);
		return null;
	}
	return <CustomRootModal modal={modal} />;
});

export default RootModalSwitch;
